'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _defineProperty = _interopDefault(require('@babel/runtime/helpers/defineProperty'));
var _objectWithoutProperties = _interopDefault(require('@babel/runtime/helpers/objectWithoutProperties'));
var React = _interopDefault(require('react'));
var reactHooks = require('@apollo/react-hooks');
var nthHookLoma = require('@narvar/nth-hook-loma');
var graphql = require('./graphql.js');

var _excluded = ["children"],
  _excluded2 = ["children"],
  _excluded3 = ["children"],
  _excluded4 = ["children"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var LomaSettingsConfigContext = /*#__PURE__*/React.createContext({
  product: 'narvarjs',
  retailerMoniker: 'DEFAULT_RETAILER',
  versionName: 'narvar'
});
var LomaSettingsConfigProvider = function LomaSettingsConfigProvider(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(LomaSettingsConfigContext.Provider, {
    value: props
  }, children);
};
var SettingsContext = /*#__PURE__*/React.createContext(undefined);
var nullRetailerSettings = {}; // maintains obj ref equality
var LomaSettingsProvider = function LomaSettingsProvider(_ref2) {
  var _data$retailerSetting;
  var children = _ref2.children,
    settingsRequested = _ref2.settingsRequested;
  var client = nthHookLoma.useLomaClient();
  var _React$useContext = React.useContext(LomaSettingsConfigContext),
    product = _React$useContext.product,
    retailerMoniker = _React$useContext.retailerMoniker,
    versionName = _React$useContext.versionName,
    localeLanguage = _React$useContext.localeLanguage,
    localeCountry = _React$useContext.localeCountry;
  var _useQuery = reactHooks.useQuery(graphql.default(settingsRequested), {
      client: client,
      variables: {
        product: product,
        retailerMoniker: retailerMoniker,
        versionName: versionName,
        localeLanguage: localeLanguage,
        localeCountry: localeCountry
      }
    }),
    loading = _useQuery.loading,
    data = _useQuery.data;
  var settings = (_data$retailerSetting = data === null || data === void 0 ? void 0 : data.retailerSettings) !== null && _data$retailerSetting !== void 0 ? _data$retailerSetting : nullRetailerSettings;
  var value = React.useMemo(function () {
    return {
      loading: loading,
      settings: settings
    };
  }, [loading, settings]);
  return /*#__PURE__*/React.createElement(SettingsContext.Provider, {
    value: value
  }, children);
};
var SettingsProviderContext = /*#__PURE__*/React.createContext(LomaSettingsProvider);
var SettingsProvider = function SettingsProvider(_ref3) {
  var children = _ref3.children,
    props = _objectWithoutProperties(_ref3, _excluded2);
  var component = React.useContext(SettingsProviderContext);
  return /*#__PURE__*/React.createElement(component, props, children);
};
var withSettingsProvider = function withSettingsProvider(component, options) {
  var _component$displayNam;
  var settingsRequested = options.settingsRequested;
  var HoC = /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(SettingsProvider, {
      settingsRequested: settingsRequested
    }, /*#__PURE__*/React.createElement(component, _objectSpread(_objectSpread({}, props), {}, {
      ref: ref
    })));
  });
  var name = (_component$displayNam = component.displayName) !== null && _component$displayNam !== void 0 ? _component$displayNam : component.name;
  HoC.displayName = "WithSettingsProvider(".concat(name, ")");
  return HoC;
};
var useSettings = function useSettings() {
  var context = React.useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettings was called without a SettingsContext');
  }
  return context.settings;
};
var useSettingsX = function useSettingsX() {
  var context = React.useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettingsX was called without a SettingsContext');
  }
  return context;
};
var LocalSettingsConfigContext = /*#__PURE__*/React.createContext({
  querySettings: function querySettings() {
    throw new Error('Not implemented');
  }
});
var LocalSettingsProvider = function LocalSettingsProvider(_ref4) {
  var children = _ref4.children,
    props = _objectWithoutProperties(_ref4, _excluded3);
  var config = React.useContext(LocalSettingsConfigContext);
  var value = config.querySettings(props);
  return /*#__PURE__*/React.createElement(SettingsContext.Provider, {
    value: value
  }, children);
};
var LocalSettingsConfigProvider = function LocalSettingsConfigProvider(_ref5) {
  var children = _ref5.children,
    props = _objectWithoutProperties(_ref5, _excluded4);
  return /*#__PURE__*/React.createElement(SettingsProviderContext.Provider, {
    value: LocalSettingsProvider
  }, /*#__PURE__*/React.createElement(LocalSettingsConfigContext.Provider, {
    value: props
  }, children));
};

exports.retailerSettingsQuery = graphql.default;
exports.LocalSettingsConfigProvider = LocalSettingsConfigProvider;
exports.LocalSettingsProvider = LocalSettingsProvider;
exports.LomaSettingsConfigProvider = LomaSettingsConfigProvider;
exports.LomaSettingsProvider = LomaSettingsProvider;
exports.SettingsProvider = SettingsProvider;
exports.useSettings = useSettings;
exports.useSettingsX = useSettingsX;
exports.withSettingsProvider = withSettingsProvider;
